import React from "react";
import { Button } from "@mui/material";
import { Flex } from "@100mslive/roomkit-react";
import { GlobeIcon, UserIcon, XIcon } from "../../icons";
import { SESSION_AUTH } from "../../common/auth";
import { externalUrlProtocol } from "../../common/utils";

const PublicProfileBanner = props => {
  const { profileData, handleFollow } = props;
  const { isUserSession } = SESSION_AUTH();

  return (
    <React.Fragment>
      <Flex className="event-page-public-profile-banner">
        <Flex className="event-page-public-profile-banner-content">
          <Flex className="event-page-public-profile-banner-content-logo">
            {profileData?.profileImage ? (
              <img
                src={profileData.profileImage}
                alt={`${profileData?.name} profile`}
              />
            ) : (
              <UserIcon />
            )}
          </Flex>
          <div className="event-page-public-profile-banner-content-info">
            <div className="event-page-public-profile-banner-content-info-name">
              {profileData?.name}
            </div>
            <div className="event-page-public-profile-banner-content-info-text">
              {profileData?.jobTitle}{" "}
              {profileData?.work ? <>at {profileData?.work} </> : null}
            </div>
            {profileData?.companyWebsite || profileData?.social?.twitter ? (
              <Flex
                gap="5px"
                className="event-page-public-profile-banner-content-info-social"
              >
                {profileData?.companyWebsite ? (
                  <a
                    href={externalUrlProtocol(profileData.companyWebsite)}
                    className="event-page-public-profile-banner-content-info-social-link"
                    target="_blank"
                    rel="noreferrer"
                    title="Webiste"
                  >
                    <GlobeIcon />
                  </a>
                ) : null}
                {profileData?.social?.twitter ? (
                  <a
                    href={`https://x.com/${profileData?.social?.twitter}`}
                    className="event-page-public-profile-banner-content-info-social-link"
                    target="_blank"
                    rel="noreferrer"
                    title={`${profileData?.name} on X`}
                  >
                    <XIcon />
                  </a>
                ) : null}
              </Flex>
            ) : null}
          </div>
        </Flex>
        {isUserSession?.userId !== profileData?.profileId ? (
          <div className="event-page-public-profile-banner-action">
            {profileData?.isFollow && isUserSession ? (
              <Button
                variant="outlined"
                color="primary"
                className="events6ix-btn events6ix-btn-primary events6ix-btn-sm"
                type="button"
                onClick={() => {
                  handleFollow("remove");
                }}
              >
                <b> FOLLOWING</b>
              </Button>
            ) : (
              <Button
                variant="outlined"
                color="primary"
                className="events6ix-btn events6ix-btn-primary events6ix-btn-sm"
                type="button"
                onClick={() => {
                  handleFollow("add");
                }}
              >
                <b> FOLLOW</b>
              </Button>
            )}
          </div>
        ) : null}
      </Flex>
    </React.Fragment>
  );
};

export default PublicProfileBanner;
